import { useEffect, useState } from 'react'

export type Route = 'board' | 'admin'

const read = (): Route => (window.location.hash.replace(/^#\/?/, '') === 'admin' ? 'admin' : 'board')

/** Hash routing on purpose: it needs no server rewrite rules to deploy. */
export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(read)
  useEffect(() => {
    const onHash = () => setRoute(read())
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])
  return route
}
